/* HYP: default collections and search to in-stock only.
   - If a /collections/ or /search page loads with no availability filter in
     the URL, redirect once adding filter.v.availability=1 (In Stock ON).
   - If the shopper turns the In Stock switch OFF, remember it for the
     session (sessionStorage) and stop forcing the filter back on.
   - Crawlers hitting the clean canonical URL still get the full list
     server-side, and product pages are untouched, so SEO keeps everything. */
(function () {
  'use strict';
  var KEY = 'hypShowSoldOut';

  try {
    var isCollection = /^\/collections\//.test(location.pathname);
    var isSearch = /^\/search\/?$/.test(location.pathname);

    if ((isCollection || isSearch) && !navigator.userAgent.match(/bot|crawl|spider|slurp|bing|duckduck/i)) {
      var qs = new URLSearchParams(location.search);

      if (!qs.has('filter.v.availability') && sessionStorage.getItem(KEY) !== '1') {
        // On search, only force the filter when an actual query is present.
        if (isCollection || qs.has('q')) {
          qs.append('filter.v.availability', '1');
          location.replace(location.pathname + '?' + qs.toString() + location.hash);
        }
      }
    }
  } catch (e) { /* never block the page */ }

  // Remember when the shopper deliberately shows sold-out items.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'filter.v.availability') return;
    try {
      if (t.checked) {
        sessionStorage.removeItem(KEY);
      } else {
        sessionStorage.setItem(KEY, '1');
      }
    } catch (err) { /* ignore */ }
  }, true);
})();
